<!-- Sidebar -->
<p-drawer
  [visible]="showBookAppointment()"
  [showCloseIcon]="false"
  position="right"
  [blockScroll]="true"
  styleClass="w-full md:w-30rem client-profile-sidebar p-0 appointment-popup"
  (onHide)="ClosePopup()"
  [dismissible]="!disableSaveBtn"
  [autoZIndex]="true"
  appendTo="body"
  aria-label="book-appointment-sidebar"
>
  <!-- Header -->
  <ng-template #header>
    <div
      class="sticky top-0 left-0 w-full surface-0 z-3 border-bottom-1 border-300 flex justify-content-between"
    >
      <div class="flex align-items-center">
        <!-- Close Icon -->
        <div
          class="h-3rem w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center"
          (click)="ClosePopup()"
          data-testid="close-sidebar-button"
        >
          <i class="fa fa-times text-xl text-600"></i>
        </div>
        <!-- Close Icon -->
        <h4
          class="mb-0 text-sm p-3 white-space-nowrap"
          aria-label="book-appointment-title"
        >
          {{ 'SCHEDULE.CREATEAPPOINTMENT.BOOK_APPOINTMENT' | translate }}
        </h4>
      </div>

      @if (currentTenant) {
        <div class="flex align-items-center justify-content-end">
          <div
            class="hidden md:flex align-items-center text-sm md:mr-5 mt-2 md:mt-0"
            aria-label="tenant-info"
          >
            <i class="fa fa-map-marker-alt text-600 mr-2"></i>
            <span>{{
              currentTenant.name_primary_language ||
                currentTenant.name_secondary_language
            }}</span>
          </div>
        </div>
      }
    </div>
  </ng-template>
  <!-- Header -->

  <ng-template #content>
    <form
      class="p-sidebar-content__wrapper flex flex-column justify-content-between surface-100"
      [formGroup]="CreateAppointmentForm"
      aria-label="appointment-form"
    >
      <!-- Content Wrapper -->
      <div class="py-3">
        <div class="px-3">
          <!-- Form Group -->
          <div class="mb-3">
            <label
              for="client_id"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="add-member-label"
            >
              {{ 'SCHEDULE.CREATEAPPOINTMENT.ADD_MEMBER' | translate }}
            </label>
            <input type="hidden" formControlName="client_id" />
            <div class="relative z-2">
              <div
                class="p-input-icon-right w-full"
                pStyleClass=".search-dropdown"
                [hideOnOutsideClick]="true"
                aria-label="client-search"
              >
                @if (miniSearchV2Enabled) {
                  <mini-search-v2
                    class="p-input-icon-right w-full"
                    [isReadonly]="false"
                    [clientId]="clientId()"
                    (clients)="setClient($event)"
                    (removedClient)="setClient(null)"
                    (createProspect)="createProspect($event)"
                    [dialogTitle]="'SCHEDULE.CREATEAPPOINTMENT.ADD_MEMBER' | translate"
                  />
                } @else {
                  <mini-search
                    class="p-input-icon-right w-full"
                    [readonly]="false"
                    [clientId]="clientId()"
                    (clients)="setClient($event)"
                    (createProspect)="createProspect($event)"
                  />
                }
                @if (
                  SelectedClientFormControl.touched &&
                  SelectedClientFormControl.invalid
                ) {
                  <app-error-msg
                    [errors]="SelectedClientFormControl.errors"
                    [fieldLabel]="
                      'SCHEDULE.CREATEAPPOINTMENT.LBL_CLIENT' | translate
                    "
                  />
                }
              </div>
            </div>
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="mb-3">
            <label
              for="selectedApptType"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="select-purpose-label"
            >
              {{ 'SCHEDULE.CREATEAPPOINTMENT.SELECT_PURPOSE' | translate }}
            </label>

            <!-- Appointment Selection for Mobile -->
            <p-select
              [options]="appointmentTypeList$ | async"
              optionLabel="name_primary_language"
              filterBy="name_primary_language"
              styleClass="w-full text-sm"
              appendTo="body"
              formControlName="selectedApptType"
              placeholder="{{
                'SCHEDULE.CREATEAPPOINTMENT.SELECT_PURPOSE_PLACE' | translate
              }}"
              (onChange)="SelectAppointmentType($event)"
              aria-label="appointment-type-dropdown"
            >
              <ng-template pTemplate="selectedItem">
                @if (selectedApptType) {
                  <div class="flex align-items-center text-sm">
                    <span class="text-{{ selectedApptType.color }}-400">{{
                      selectedApptType.name_primary_language
                    }}</span>
                    @if (selectedApptType.logo) {
                      <span class="{{ selectedApptType.logo }} ml-3"></span>
                    }
                  </div>
                }
              </ng-template>
              <ng-template let-appointmentType pTemplate="item">
                <div class="flex align-items-center text-sm">
                  <span
                    class="text-{{
                      appointmentType.color
                    }}-400 text-white-highlight"
                    >{{ appointmentType.name_primary_language }}</span
                  >
                  @if (appointmentType.logo) {
                    <span class="{{ appointmentType.logo }} ml-3"></span>
                  }
                </div>
              </ng-template>
            </p-select>
            <!-- Appointment Selection for Mobile -->
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          @if (showApptSubType | async) {
            <div class="mb-3">
              <label
                for="selectedApptSubType"
                class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="select-sub-purpose-label"
              >
                {{
                  'SCHEDULE.CREATEAPPOINTMENT.SELECT_SUB_PURPOSE' | translate
                }}
              </label>
              <!-- For Desktop -->
              <div
                class="hidden md:flex p-buttonset"
                aria-label="sub-purpose-buttons"
              >
                @for (
                  subType of appointmentSubTypeList$ | async;
                  track subType;
                  let i = $index
                ) {
                  <button
                    pButton
                    pRipple
                    [ngClass]="
                      selectedApptSubType! && selectedApptSubType === subType
                        ? 'text-sm border-right-1 border-white'
                        : 'p-button-secondary text-sm border-right-1 border-white border-1'
                    "
                    type="button"
                    (click)="SelectAppointmentSubType(subType)"
                    [attr.aria-label]="
                      'sub-purpose-button-' + subType.name_primary_language
                    "
                  >
                    <span class="ml-2">{{
                      subType.name_primary_language
                    }}</span>
                  </button>
                }
              </div>
              <!-- For Desktop -->
              <!-- For Mobile -->
              <div class="md:hidden">
                <p-select
                  [options]="appointmentSubTypeList$ | async"
                  optionLabel="name_primary_language"
                  filterBy="name_primary_language"
                  styleClass="w-full text-sm"
                  formControlName="selectedApptSubType"
                  placeholder="{{
                    'SCHEDULE.CREATEAPPOINTMENT.SELECTWITHDOTS' | translate
                  }}"
                  (onChange)="SelectAppointmentSubType($event)"
                  aria-label="sub-purpose-dropdown"
                >
                  <ng-template pTemplate="selectedItem">
                    @if (selectedApptSubType) {
                      <div class="text-sm">
                        {{ selectedApptSubType.name_primary_language }}
                      </div>
                    }
                  </ng-template>
                  <ng-template let-subApptType pTemplate="item">
                    <span class="text-sm">{{
                      subApptType.name_primary_language
                    }}</span>
                  </ng-template>
                </p-select>
              </div>
              <!-- For Mobile -->
            </div>
          }
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="mb-3">
            <label
              for="isVirtal"
              class="font-medium text-700 text-xs mb-2 block uppercase"
              aria-label="appointment-type-label"
              >{{ 'SCHEDULE.CREATEAPPOINTMENT.APPT_TYPE' | translate }}</label
            >
            <div class="p-buttonset" aria-label="appointment-type-buttons">
              <button
                pButton
                pRipple
                icon="fa fa-users"
                label="{{ 'SCHEDULE.CREATEAPPOINTMENT.PHYSICAL' | translate }}"
                type="button"
                class="text-sm border-right-1 border-white"
                (click)="SetIsVirtual(false)"
                [ngClass]="
                  isVirtal === false ? 'border-white' : 'p-button-secondary'
                "
                aria-label="physical-appointment-button"
              ></button>
              <button
                pButton
                pRipple
                icon="fa fa-video"
                label="{{ 'SCHEDULE.CREATEAPPOINTMENT.VIRTUAL' | translate }}"
                type="button"
                class="text-sm border-right-1 border-white"
                (click)="SetIsVirtual(true)"
                [ngClass]="isVirtal ? 'border-white' : 'p-button-secondary'"
                aria-label="virtual-appointment-button"
              ></button>
            </div>
          </div>
          <!-- Form Group -->
        </div>

        <hr
          class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
        />

        <!-- Form Group -->
        <div class="mb-0 px-3">
          <label
            for="selectedTrainer"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            aria-label="select-trainer-label"
            >{{ 'SCHEDULE.CREATECLASS.SELECTTRAINER' | translate }}</label
          >
          <input type="hidden" formControlName="selectedTrainer" />
          <staff-selector
            [formGroup]="CreateAppointmentForm"
            [controlName]="SelectedAssignedFormControl"
            [styleClass]="'w-full text-sm'"
            [placeHolder]="'common.PLACEHOLDER.SEARCH_AND_SELECT' | translate"
            [filterstaff]="filterStaffIds"
            aria-label="trainer-selector"
          />
          @if (
            SelectedAssignedFormControl.touched &&
            SelectedAssignedFormControl.invalid
          ) {
            <app-error-msg
              [errors]="SelectedAssignedFormControl.errors"
              [fieldLabel]="
                'SCHEDULE.CREATEAPPOINTMENT.LBL_TRAINER' | translate
              "
            />
          }
        </div>

        <div class="-mt-2 px-1">
          @if (!isStaffAvailable && !showSkeleton) {
            <p-message
              severity="error"
              icon="fa-times-circle"
              aria-label="staff-unavailable-message"
              data-testid="staff-unavailable-message"
            >
              {{
                'STAFF_SCHEDULE.MSG.STAFF_UNAVAILABLE_MSG_LIN_INFO'
                  | translate: { name: SelectedAssignedFormControl.value.name }
              }}
            </p-message>
          }
          @if (showSkeleton) {
            <p-skeleton
              height="2.5rem"
              styleClass="my-3"
              aria-label="loading-skeleton"
            />
          }
        </div>
        <!-- Form Group -->

        <hr
          class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3"
        />

        <div class="px-3">
          <!-- Form Group -->
          <div class="grid md:pl-2">
            <div class="col-12 relative pl-5">
              <label
                for="startDate"
                class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="datetime-label"
                >{{ 'SCHEDULE.VIEWCLASS.LBL_DATETIME' | translate }}</label
              >
              <i
                class="fa fa-calendar-plus absolute left-0 mt-2 text-600"
                aria-label="calendar-icon"
              ></i>

              <p-datepicker
                inputId="calendar-12h"
                formControlName="startDate"
                [showTime]="true"
                styleClass="text-sm w-full"
                inputstyleClass="text-sm m-0 border-400 h-2rem border-round"
                [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate"
                [minDate]="minimumDate"
                hourFormat="12"
                (onClose)="checkStaffAvailability()"
                aria-label="datetime-calendar"
              />

              @if (
                StartDateFormControl.touched && StartDateFormControl.invalid
              ) {
                <app-error-msg
                  [errors]="StartDateFormControl.errors"
                  [fieldLabel]="
                    'SCHEDULE.CREATEAPPOINTMENT.LBL_STARTDATE' | translate
                  "
                />
              }
            </div>
            <div
              class="col-12 pl-5"
              [ngClass]="!RRuleObject.RRuleText ? 'md:col-6' : 'md:col-12'"
            >
              <!-- Input Field -->
              @if (!RRuleObject.RRuleText) {
                <div
                  class="p-input-icon-right w-full text-sm"
                  (click)="showRRule = true"
                  data-testid="repeat-input"
                >
                  <div
                    class="p-inputtext p-component p-element cursor-pointer bg-blue-50"
                  >
                    {{ 'SCHEDULE.CREATEAPPOINTMENT.REPEAT' | translate }}
                  </div>
                </div>
              }
              @if (RRuleObject.RRuleText) {
                <div
                  class="p-input-icon-right w-full text-sm cursor-pointer"
                  aria-label="repeat-selected"
                >
                  <i
                    class="fa fa-times text-xl text-600"
                    (click)="
                      showRRule = false;
                      RRuleObject.RRule = '';
                      RRuleObject.RRuleText = '';
                      checkStaffAvailability()
                    "
                    data-testid="clear-repeat"
                  ></i>
                  <div
                    class="p-inputtext p-component p-element w-full"
                    (click)="showRRule = true"
                  >
                    {{ RRuleObject.RRuleText }}
                  </div>
                </div>
              }
              <!-- Input Field -->
            </div>

            <!-- Form Group -->
            @if (!isVirtal) {
              <div class="col-12 relative pl-5">
                <i
                  class="fa fa-building absolute left-0 mt-2 pt-1 text-600"
                  aria-label="room-icon"
                ></i>
                <select-room
                  [formGroup]="CreateAppointmentForm"
                  [controlName]="SelectedRoomFormControl"
                  [tenantId]="tenantId()"
                  aria-label="room-selector"
                />
                @if (
                  SelectedRoomFormControl.touched &&
                  SelectedRoomFormControl.invalid
                ) {
                  <app-error-msg
                    [errors]="SelectedRoomFormControl.errors"
                    [fieldLabel]="
                      'SCHEDULE.CREATEAPPOINTMENT.LBL_ROOM' | translate
                    "
                  />
                }
              </div>
            }
            <!-- Form Group -->

            <!-- Form Group -->
            @if (isVirtal) {
              <div class="col-12 relative pl-5">
                <i
                  class="fa fa-paperclip absolute left-0 mt-2 pt-1 text-600"
                  aria-label="url-icon"
                ></i>
                <input
                  type="text"
                  class="text-sm w-full"
                  pInputText
                  formControlName="virtualUrl"
                  placeholder="{{
                    'SCHEDULE.CREATEAPPOINTMENT.VIRTUALURL' | translate
                  }}"
                  aria-label="virtual-url-input"
                />
                @if (
                  VirtualUrlFormControl.touched && VirtualUrlFormControl.invalid
                ) {
                  <app-error-msg
                    [errors]="VirtualUrlFormControl.errors"
                    [fieldLabel]="
                      'SCHEDULE.CREATEAPPOINTMENT.LBL_VIRTUALURL' | translate
                    "
                  />
                }
              </div>
            }
            <!-- Form Group -->

            <!-- Form Group -->
            <div class="col-12 mb-0 relative pl-5">
              <i
                class="fa fa-align-left absolute left-0 mt-2 pt-1 text-600"
                aria-label="comments-icon"
              ></i>
              <textarea
                pInputTextarea
                class="text-sm w-full h-4rem"
                formControlName="comments"
                placeholder="{{
                  'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate
                }}"
                aria-label="comments-textarea"
              >
              </textarea>
            </div>
            <!-- Form Group -->
          </div>
          <!-- Form Group -->
        </div>
      </div>
      <!-- Content Wrapper -->

      <!-- Footer -->
      <div
        class="sticky bottom-0 left-0 w-full surface-0 z-3 flex align-items-center justify-content-between border-top-1 border-300 p-3"
      >
        <div class="w-4">
          <p-button
            label="{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}"
            styleClass="p-button-link text-sm"
            (click)="ClosePopup()"
            aria-label="cancel-button"
          />
        </div>
        <div class="w-8 text-right">
          <p-confirmpopup key="bookconfirm" />
          <button
            class="text-sm"
            pButton
            pRipple
            [label]="'SCHEDULE.CREATEAPPOINTMENT.CREATE_APPT' | translate"
            type="button"
            [disabled]="disableSaveBtn"
            [loading]="disableSaveBtn"
            (click)="
              isStaffAvailable
                ? CreateAppointment(CreateAppointmentForm)
                : confirm($event)
            "
            aria-label="create-appointment-button"
          ></button>
        </div>
      </div>
      <!-- Footer -->
    </form>
  </ng-template>

  <p-toast
    key="bookappointment"
    [autoZIndex]="true"
    position="top-right"
    [breakpoints]="{ '767px': { width: '100%', left: '0' } }"
  />
</p-drawer>
<!-- Sidebar -->

<!-- Choose Subscription Modal  -->
<p-dialog
  [visible]="chooseSubscriptionModal"
  (onHide)="closeBookingPopup()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '991px': '100vw' }"
  [style]="{ width: '600px' }"
  styleClass="no-header-modal overflow-visible"
  aria-label="choose-subscription-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="md:px-3 md:pt-3 p-2 md:flex align-items-center justify-content-between border-bottom-1 border-300"
    >
      <div class="md:flex align-items-center">
        <span
          class="block md:flex flex-wrap align-items-center text-sm md:text-base mr-3"
        >
          <strong aria-label="choose-subscription-title">{{
            'SCHEDULE.CREATEAPPOINTMENT.CHOOSE_SUBS' | translate
          }}</strong>
          <span class="block md:hidden">
            <hr
              class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-2"
            />
          </span>
          <span class="flex align-items-center">
            <div class="h-2rem w-2rem mx-2 relative">
              @if (selectedclient.clt_image) {
                <p-avatar
                  [image]="selectedclient.clt_image"
                  shape="circle"
                  aria-label="client-avatar"
                />
              } @else {
                <p-avatar
                  [label]="selectedclient.clt_full_name | titlecase | shortName"
                  shape="circle"
                  aria-label="client-avatar-placeholder"
                />
              }
              <span
                class="w-1rem h-1rem border-circle flex align-items-center justify-content-center surface-400 absolute right-0 bottom-0 -mb-1 -mr-1"
              >
                <i
                  class="fa fa-star-fill text-primary text-xxs"
                  aria-label="star-icon"
                ></i>
              </span>
            </div>
            <br class="md:hidden" />
            <strong aria-label="client-name">{{
              selectedclient.clt_full_name
            }}</strong>
            <span class="text-500 text-xs ml-1" aria-label="client-id">
              - {{ selectedclient.clt_id }}</span
            >
          </span>
        </span>
      </div>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer absolute md:static top-0 right-0 mt-2 mr-2 md:m-0"
        (click)="chooseSubscriptionModal = false"
        data-testid="close-subscription-dialog"
      ></div>
    </div>
    <!-- Header -->

    <!-- Modal Content -->
    <div class="surface-0">
      <div class="-my-3">
        <p-message severity="warn" aria-label="subscription-warning">
          <div class="p-warn flex align-items-center w-full -my-2">
            <i
              class="fa fa-exclamation-triangle p-warn text-xl"
              aria-label="warning-icon"
            ></i>
            <div class="ml-2 line-height-3 text-xs">
              {{
                'SCHEDULE.CREATEAPPOINTMENT.CHOOSE_FOR'
                  | translate
                    : {
                        clientname: selectedclient.clt_full_name,
                        clientid: selectedclient.clt_id,
                      }
              }}
              <strong>{{
                'SCHEDULE.CREATEAPPOINTMENT.MULTIPLE_SUBS' | translate
              }}</strong>
              {{ 'SCHEDULE.CREATEAPPOINTMENT.MULTIPLE_SUBS_INFO' | translate }}
            </div>
          </div>
        </p-message>
      </div>

      <div class="surface-100 p-3">
        <!-- Form Group -->
        <label
          for="selectedMembership"
          class="font-medium text-700 text-xs mb-2 block uppercase"
          aria-label="subscriptions-label"
          >{{ 'SCHEDULE.CREATEAPPOINTMENT.SUBSCRIPTIONS' | translate }}</label
        >
        <p-select
          [options]="clientMemberships"
          [(ngModel)]="selectedMembership"
          optionLabel="service_category_primary_name"
          filterBy="service_category_primary_name"
          styleClass="w-full text-sm"
          [placeholder]="
            'SCHEDULE.CREATEAPPOINTMENT.CHOOSE_SUBS_PLACEHOLDER' | translate
          "
          (onChange)="ChangeMembership($event)"
          aria-label="subscription-dropdown"
        >
          <ng-template pTemplate="selectedItem">
            @if (selectedMembership) {
              <div class="text-sm">
                {{ selectedMembership.subscription_primary_name }} -
                {{ selectedMembership.service_category_primary_name }}
              </div>
            }
          </ng-template>
          <ng-template let-membership pTemplate="item">
            <div class="text-sm ml-2">
              {{ membership.subscription_primary_name }} -
              {{ membership.service_category_primary_name }}
            </div>
          </ng-template>
        </p-select>
        <!-- Form Group -->
      </div>
    </div>
    <!-- Modal Content -->

    <!-- Modal Footer -->
    <div class="px-4 py-3 border-top-1 text-right border-300">
      <button
        pButton
        pRipple
        [label]="'SCHEDULE.CREATEAPPOINTMENT.BTN_CONTINUE' | translate"
        styleClass="text-sm"
        (click)="closeBookingPopup()"
        aria-label="continue-button"
      ></button>
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
<!-- Choose Subscription Modal  -->

@if (showRRule) {
  <app-rrule
    [visible]="showRRule"
    [showNeverStop]="true"
    [minimumDate]="minimumDate"
    [rRuleObj]="RRuleObject"
    (hideRrule)="HideRRule($event)"
    (emitRRule)="FetchRRuleData($event)"
    aria-label="recurrence-rule-dialog"
  />
}

@if (showErrorPopup$ | async; as showPopup) {
  <app-errors
    [error]="error"
    [visible]="showPopup"
    [errorData]="errorMessages"
    (hideErrorPopup)="HideErrorPopup($event)"
    aria-label="error-dialog"
  />
}

<!-- Models Prospect Start -->
@if (showCreateProspectPopup$ | async; as showPopup) {
  <create-client-profile-sidebar
    [showProspect]="showPopup"
    [formType]="'prospect'"
    (hideProspect)="hidePopup($event)"
    aria-label="create-prospect-dialog"
  />
}
<!-- Models Prospect End -->
